import {API_URL} from "../common/const";

export const endpoints = {

    //LOGIN
    login: `${API_URL}/auth/signin`,
    JWTRefresh: `${API_URL}/auth/refreshToken`,
    temporalPassword: `${API_URL}/auth/temporalPassword`,
    // Forgot password
    forgotPassword: `${API_URL}/forgot-password`,

    //AJustes
    users: `${API_URL}/users`,
    userEmpByUser: `${API_URL}/user-empresa/user/`,
    menus: `${API_URL}/menus/`,
    menuRole: `${API_URL}/menu-role/`,
    userEmpMnByUser: `${API_URL}/menus/find-pantallas`,
    userEmpValUserComp: `${API_URL}/user-empresa/user-not-company/?idUser=`,
    empresa: `${API_URL}/empresa/`,
    sucursalByEmpresa: `${API_URL}/sucursal/find-empresa/`,
    localBySucursal: `${API_URL}/local/find-sucursal/`,
    roles: `${API_URL}/role/`,
    adminActions: `${API_URL}/action/`,
    adminRMA: `${API_URL}/role-menu-action/`,
    permissions: `${API_URL}/role-menu-action/permissions`,

    //Inventario
    invProductos: `${API_URL}/productos/`,

    //Param
    paramTipoContribuyente: `${API_URL}/tipo-contribuyente/`,
    paramIdentifications: `${API_URL}/identificacion/`,
    paramNivelUbicaciones: `${API_URL}/nivel-ubicaciones/`,
    paramUbicaciones: `${API_URL}/ubicaciones/`,
    paramComprobantes: `${API_URL}/comprobantes/find-grupo/`,
    paramComprobantesPadre: `${API_URL}/comprobantes/find-grupo-padre/`,
    paramComprobantesGroup: `${API_URL}/comprobantes/find-grupos`,
    paramComprobantesSri: `${API_URL}/comprobante-sri/`,
    paramFormaCredito: `${API_URL}/forma_creditos/`,
    paramFormaCreditoByTipo: `${API_URL}/forma-creditos/find-tipo/`,
    paramFormaPagoSri: `${API_URL}/forma-pago-sri/`,
    paramSriTipoSustento: `${API_URL}/sri-tipo-sustento/`,
    paramSriRetencionIva: `${API_URL}/sri-retencion-iva/`,
    paramSriRetencionFuente: `${API_URL}/sri-retencion-fuente/`,
    paramFormaCobroPago: `${API_URL}/forma-cobro-pagos/`,
    paramFCPCategory: `${API_URL}/forma-cobro-pagos/find-category-tipo?`,
    paramCategoriaFormaCobroPago: `${API_URL}/categoria-forma=cobro-pagos/find-empresa/`,
    IVAPorcentaje: `${API_URL}/impuesto/iva-current/`,
    paramImpuesto: `${API_URL}/impuesto/`,
    paramMotivos: `${API_URL}/motivos/`,
    paramRetencion: `${API_URL}/retencion/`,

    //Param TipoGasto
    tipoGastoActivos: `${API_URL}/tipo-gasto/activos/`,

    //Banco
    cuentaBancaria: `${API_URL}/cuenta-bancaria/`,
    bancos: `${API_URL}/bancos/`,
    cierreCajaMensual: `${API_URL}/cierre-caja/mensual/`,
    cierreCajaReporte: `${API_URL}/cierre-caja/reporte/?`,
    chequerasReporte: `${API_URL}/chequeras/reporte/?`,
    movimientosBancos: `${API_URL}/movimientos-bancos/`,
    movimientosBancosFindParams: `${API_URL}/banco-transaccion/find-params/?`,
    movimientosBancosCreate: `${API_URL}/movimientos-bancos/`,
    movimientosBancosAnular: `${API_URL}/movimientos-bancos/anular/`,
    movimientosBancosContabilizar: `${API_URL}/banco-transaccion/contabilizar`,

    //Ventas
    proformas: `${API_URL}/proformas/`,
    venNotaCredito: `${API_URL}/nota-credito/`,
    venNotaCreditoFindParams: `${API_URL}/nota-credito/find-params/?`,
    venInvoicesFindParams: `${API_URL}/transaccion/find-params/?`,
    venClientes: `${API_URL}/clientes/`,
    venClientesTipo: `${API_URL}/clientes/find-tipo/`,
    venClientesnumIdAndEmpresa: `${API_URL}/clientes/ruc-cedula/`,
    venClientesEmpresa: `${API_URL}/clientes/find-empresa/`,
    venVendedor: `${API_URL}/vendedor/`,
    venVendedorEmpresa: `${API_URL}/vendedor/find-empresa/`,
    venFacturas: `${API_URL}/transaccion/`,
    venFacturasPdf: `${API_URL}/transaccion/pdf/?`,
    venFacturasRide: `${API_URL}/transaccion/ride/`,
    venFacturasChart: `${API_URL}/transaccion/find-chart/`,
    venVehiculos: `${API_URL}/vehiculos/`,
    venSocioVehiculos: `${API_URL}/socio-vehiculo/`,
    venSocioVehiculo: `${API_URL}/socio-vehiculo/find-socio/`,
    venMarcas: `${API_URL}/marcas/`,
    venAportes: `${API_URL}/aportes/`,
    venCtaXCobrar: `${API_URL}/cta-x-cobrar/`,
    venCxcReporteCartera: `${API_URL}/cta-x-cobrar/reporte-cartera/?`,
    venCxcReporteMovimientos: `${API_URL}/cta-x-cobrar/reporte-movimientos/?`,
    venCobroCxc: `${API_URL}/cobro-cxc/`,
    venRetencion: `${API_URL}/venta-retencion/`,
    venRetencionParams: `${API_URL}/venta-retencion/find-params/?`,
    venTransaccionXml: `${API_URL}/transaccion-xml/`,

    cobros: `${API_URL}/banco-transaccion/`,
    cobrosSave: `${API_URL}/cta-x-cobrar/create-cobro/`,

    // Compras
    comFacturas: `${API_URL}/compra-transaccion/`,
    comProveedores: `${API_URL}/proveedores/`,
    comProveedoresEmpresa: `${API_URL}/proveedores/find-empresa/`,
    comPagos: `${API_URL}/banco-transaccion/`,
    comCtaXPagar: `${API_URL}/cta-x-pagar/`,
    comCxpReporteCartera: `${API_URL}/cta-x-pagar/reporte-cartera/?`,
    comCxpReporteMovimientos: `${API_URL}/cta-x-pagar/reporte-movimientos/?`,
    comPagoXFactura: `${API_URL}/pago-factura/`,
    comRetencion: `${API_URL}/compra-retencion/`,
    comRetencionReporteImpuestos: `${API_URL}/compra-retencion/reporte-impuestos/?`,
    comRetencionParams: `${API_URL}/compra-retencion/find-params/?`,

    //Creditos
    creditoParam: `${API_URL}/parametro-credito/`,
    creditos: `${API_URL}/creditos/`,

    //Contabilidad
    paramGrupoComprobantes: `${API_URL}/grupo_comprobantes/`,
    paramGrupoComprobantesActivos: `${API_URL}/grupo_comprobantes/activos/`,
    contabIntegracion: `${API_URL}/contab-integracion/`,
    contabLoteFindParams: `${API_URL}/contabilidad/lote/find-params`,
    contabLoteContabilizar: `${API_URL}/contabilidad/lote/contabilizar`,
    contabAnular: `${API_URL}/contabilidad/`,
    contabAsientoFindParams: `${API_URL}/contabilidad/asiento/find-params`,
    contabAsientoFindById: `${API_URL}/contabilidad/asiento/find-by-id`,
    contabAsientoGuardar: `${API_URL}/contabilidad/asiento/guardar`,
    contabAsientoAnular: `${API_URL}/contabilidad/asiento/anular`,
    contabPlanCuenta: `${API_URL}/plan-cuenta/`,
    contabAtsParams: `${API_URL}/ats/find-params/?`,
    contabAtsGenerar: `${API_URL}/contabilidad/ats/`,
    // Endpoint para descargar el archivo ATS (devuelve application/xml con Content-Disposition)
    contabAtsDownload: `${API_URL}/contabilidad/ats/download`,
    // Endpoint para obtener el listado de ATS (ventas, compras, retenciones, anulados)
    contabAtsListado: `${API_URL}/contabilidad/ats/listado`,

    // Reportes Contabilidad
    contabRptDiarioGeneral: `${API_URL}/reporte-contab/diario-general`,
    contabRptEstadoCuenta: `${API_URL}/reporte-contab/estado-cuenta`,
    contabRptBalanceGeneral: `${API_URL}/reporte-contab/balance-general`,
    contabRptEstadoResultados: `${API_URL}/reporte-contab/estado-resultados`,
    contabRptPdfDiarioGeneral: `${API_URL}/reporte-contab/pdf/diario-general`,
    contabRptPdfEstadoCuenta: `${API_URL}/reporte-contab/pdf/estado-cuenta`,
    contabRptPdfBalanceGeneral: `${API_URL}/reporte-contab/pdf/balance-general`,
    contabRptPdfEstadoResultados: `${API_URL}/reporte-contab/pdf/estado-resultados`,

    //Cliente Socio
    oficios: `${API_URL}/oficios/`,
    certificadoNoAdeudar: `${API_URL}/certificados-no-adeudar/`,
    clasificacionMulta: `${API_URL}/clasificacion-multa/`,
    detalleMulta: `${API_URL}/detalle-multa/`,
    multas: `${API_URL}/multa-transaccion/`,
};
